import { render, staticRenderFns } from "./baikeDetail.vue?vue&type=template&id=4ef362ce&scoped=true"
import script from "./baikeDetail.vue?vue&type=script&lang=js"
export * from "./baikeDetail.vue?vue&type=script&lang=js"
import style0 from "./baikeDetail.vue?vue&type=style&index=0&id=4ef362ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef362ce",
  null
  
)

export default component.exports